import axios from "axios";

const baseUrl = process.env.REACT_APP_MAIN_API_Url;

const LoggerService = {
  getLogs: async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/logger`);
      return response.data;
    } catch (error) {
      console.error("Error fetching logs", error);
      throw error;
    }
  },

  generateError: async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/logger/generate-error`);
      return response.data;
    } catch (error) {
      console.error("Error generating error", error);
      throw error;
    }
  },

  deleteLogs: async () => {
    try {
      const response = await axios.delete(`${baseUrl}/api/logger/delete-logs`);
      return response.data;
    } catch (error) {
      console.error("Error deleting logs", error);
      throw error;
    }
  },


  // Add these new methods
  getSystemResources: async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/resourcemonitor/resources`);
      return response.data;
    } catch (error) {
      console.error("Error fetching system resources", error);
      throw error;
    }
  },

  checkResources: async () => {
    try {
      const response = await axios.post(`${baseUrl}/api/resourcemonitor/check`);
      return response.data;
    } catch (error) {
      console.error("Error checking resources", error);
      throw error;
    }
  },
};

export default LoggerService;